<template>
<div class="canvas-container" ref="canvas-container"></div>    
</template>

<script>
import Stage from './model'

export default {
  mounted () {
      Stage.initialize(this.$refs['canvas-container'])
  },
  beforeDestroy () {
    Stage.destroy()
  }
  
}
</script>

<style>
 .canvas-container {
    width: 200px;
    height: 200px;
    background-color: brown;
  }
</style>


// WEBPACK FOOTER //
// src/components/3DProjects/BasicTest.vue